import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ButtonIcon from "~/components/ButtonIcon";
import PlayCircleOutline from "~/components/MaterialIcons/PlayCircleOutline";
import { StyledButton, StyledButtonText } from "./WatchButton.styles";
var WatchButton = function(param) {
    var label = param.label, onClick = param.onClick;
    return /*#__PURE__*/ _jsxs(StyledButton, {
        color: "grey",
        onClick: onClick,
        size: "small",
        variant: "text",
        children: [
            /*#__PURE__*/ _jsx(ButtonIcon, {
                size: 17,
                children: /*#__PURE__*/ _jsx(PlayCircleOutline, {})
            }),
            /*#__PURE__*/ _jsx(StyledButtonText, {
                variant: "button",
                children: label
            })
        ]
    });
};
export default WatchButton;
